// src/prompts/p03_delamination.js — ICRI 210.1R (2 steps)

export const PROMPT_P03_STEP1 = () => `
Analyze for DELAMINATION / SUBSURFACE VOIDS (ICRI 210.1R).
NOTE: Partial visual diagnosis — percussion test required for confirmation.

Visual indicators: surface blistering, horizontal cracks parallel to surface,
circular/irregular discoloration, context (slab on grade, parking deck, elevated slab).

Return ONLY this JSON:
{
  "pathology_id": "p03_delamination",
  "pathology_name": { "es": "Delaminación y huecos", "en": "Delamination and voids" },
  "norm": "ICRI 210.1R",
  "confidence": 45,
  "requires_additional_input": true,
  "visual_indicators_present": true,
  "probable_origin": "finishing_over_bleed_water|freeze_thaw|shrinkage|unknown",
  "root_cause": { "es": "Diagnóstico provisional — prueba de percusión requerida", "en": "Provisional diagnosis — percussion test required" },
  "severity": "pending_percussion_test",
  "urgency": "pending_percussion_test",
  "additional_input": {
    "method": "percussion_test",
    "instructions": {
      "es": "Arrastra una cadena metálica sobre la superficie. ¿Escuchas sonido hueco?",
      "en": "Drag a chain or tap with a rod across the surface. Do you hear a hollow sound?"
    }
  },
  "disclaimer": {
    "es": "Diagnóstico visual preliminar. La prueba de percusión es obligatoria (ICRI 210.1R).",
    "en": "Preliminary visual diagnosis. Percussion test is mandatory (ICRI 210.1R)."
  }
}`;

export const PROMPT_P03_STEP2 = (percussionResult = '', sponsorProduct = 'Sika MonoTop-410 + Sikafloor-81 EpoCem') => `
Complete DELAMINATION diagnosis (ICRI 210.1R).
Percussion test result from inspector: "${percussionResult}"

Return ONLY this JSON:
{
  "pathology_id": "p03_delamination",
  "pathology_name": { "es": "Delaminación y huecos", "en": "Delamination and voids" },
  "norm": "ICRI 210.1R",
  "confidence": 85,
  "requires_additional_input": false,
  "delamination_confirmed": true,
  "hollow_area_estimate": "localized <1m²|moderate 1–5m²|extensive >5m²|unknown",
  "root_cause": { "es": "...", "en": "..." },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": [
        "1. Mapeo completo con cadena de arrastre o GPR (ICRI 210.1R)",
        "2. Corte perimetral con disco diamantado",
        "3. Demolición mecánica hasta substrato sólido (CSP 5–9)",
        "4. Puente de adherencia + overlay de concreto o mortero alta adherencia",
        "5. Acabado y curado húmedo mínimo 7 días"
      ],
      "en": [
        "1. Full mapping with chain drag or GPR (ICRI 210.1R)",
        "2. Perimeter saw-cut with diamond blade",
        "3. Mechanical removal to solid substrate (CSP 5–9)",
        "4. Bonding agent + concrete overlay or high-bond repair mortar",
        "5. Finish and wet cure minimum 7 days"
      ]
    },
    "norm_reference": "ICRI 210.1R-2008; ACI 302.1R-15 Sec. 9"
  },
  "materials": {
    "generic": { "es": "Puente base cemento; overlay a/c ≤0.40", "en": "Cement bonding agent; overlay w/c ≤0.40" },
    "premium": { "product": "${sponsorProduct}", "brand": "Sika", "note": { "es": "Certificado tráfico vehicular", "en": "Certified for vehicular traffic" } }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": {
    "es": "Para áreas >5m² se recomienda GPR. No sustituye inspección pericial.",
    "en": "For areas >5m² GPR is recommended. Does not replace expert inspection."
  }
}`;
